<template>
  <div>
    <div class="card">
      <div class="card-body">
        <div class="d-flex mb-1">
          <div class="mr-3">
            <i class="fas fa-map-marked-alt text-muted"></i>
          </div>
          <div>
            <template v-if="(addressFirstRow || addressSecondRow)">
              <small> 
                  {{ addressFirstRow }}
              </small>
              <br>
              <small> 
                  {{ addressSecondRow }}
              </small>
            </template>
            <template v-else>
              -
            </template>
          </div>
        </div>

        <div class="d-flex">
          <div class="mr-3">
            <i class="fas fa-phone-alt text-muted"></i>
          </div>
          <div>
            <template v-if="(contactFirstRow || contactSecondRow)">
              <small> 
                  {{ contactFirstRow }}
              </small>
              <br>
              <small> 
                  {{ contactSecondRow }}
              </small>
            </template>
            <template v-else>
              -
            </template>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

export default {

  props : {
    person : {
      required : true
    }
  },

  computed : {
    addressFirstRow () {
      return [this.person.address, this.person.number, this.person.complement].filter(Boolean).join(', ') 
    },

    addressSecondRow () {
      var city = (this.person.city) ? this.person.city + ' - ' + this.person.state : null 

      return [this.person.district, city, this.person.zipcode ].filter(Boolean).join(', ') 
    },

    contactFirstRow() {
      return [this.formatPhone(this.person.phone_wa), this.formatPhone(this.person.phone2)].filter(Boolean).join(' | ') 
    },

    contactSecondRow() {
      return [this.formatPhone(this.person.phone3), this.formatPhone(this.person.phone4)].filter(Boolean).join(' | ') 
    }


  },

  methods : {

    formatPhone(v) {
      if (v) {

        v=v.replace(/\D/g,"");//Remove tudo o que não é dígito
        v=v.replace(/^(\d{2})(\d)/g,"($1) $2");//Coloca parênteses em volta dos dois primeiros dígitos
        v=v.replace(/(\d)(\d{4})$/,"$1-$2");//Coloca hífen entre o quarto e o quinto dígitos
        return v;
      }

      return null
    }
  }


};
</script>

<style>
</style>